import axios from 'axios';

export const weather = axios.create({
	baseURL: 'https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=',
});

export const astronomy = axios.create({
	baseURL: 'https://retoolapi.dev/',
});

export const openWeather = axios.create({
	baseURL: 'https://api.openweathermap.org/data/2.5',
});
